import React from 'react'
import SmartLink from '@/component/Primitive/SmartLink'

import styles from './MediaVersions.module.scss'

const MediaVersionsNote = () => (
  <tr>
    <td className={styles.Note} colSpan={6}>
      Please note: each rating can only be used for the distribution method
      listed in the Use column. For more information on each Use click{' '}
      <SmartLink as="/rating-use" to="/rating-use">
        here
      </SmartLink>
      .
    </td>
  </tr>
)

export default MediaVersionsNote
